import React from "react";
import "./topNav.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faUser } from '@fortawesome/free-solid-svg-icons'
import logo from './../../assets/img/JBM-Logo-transparent.png'
import $ from 'jquery'
import Dropdown from 'react-bootstrap/Dropdown';
import LockScreen from "../LockScreen/LockScreen";
import {Logout} from "../../utils";
//import Navbar from 'react-bootstrap/Navbar';

function TopNav(props) {
    const handlerLSC = function(){
      props.setShowLS(true);
    };
    const handlerLGT = function(){
      Logout();
    };
    return (<header className="mainHeader">
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div id="mainMenuToggleBtn" className="mainMenuToggleBtn" onClick={toggleSidebar}><FontAwesomeIcon icon={faBars}/></div>
        <div id="mobileMenuToggleBtn" className="mainMenuToggleBtn" onClick={toggleMobileSidebar}><FontAwesomeIcon icon={faBars}/></div>
        <a className="navbar-brand" href="/">
            <img src={logo} alt=""/>
        </a>
        <div className="navbar-nav mr-auto nav-right">
            <Dropdown className="nav-item dropdown">
              <Dropdown.Toggle className="nav-link dropdown-toggle"><FontAwesomeIcon icon={faUser}/></Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item className="nav-link" href="#" id="toggleTheme" onClick={toggleTheme}><span>Dark Theme</span><span className="d-none">Light Theme</span></Dropdown.Item>
                <Dropdown.Item className="nav-link" href="#" onClick={handlerLSC}>LockScreen</Dropdown.Item>
                <Dropdown.Item className="nav-link" href="#" onClick={handlerLGT}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
        </div>
    </nav>
</header>
);
}

export default TopNav;

function toggleSidebar() {
    $('#mainSidebar').toggleClass('compactView');
    $('#mainContent').toggleClass('expendView');
}

function toggleMobileSidebar() {
    $('#mainSidebar').toggle();
}

function toggleTheme() {
    let $body = $('body');
    $body.toggleClass('darkVersion');
    $('#toggleTheme span').toggleClass('d-none');
}

$("#mainMenu a.list-group-item").click(function () {
    $(this).find("i.fa-angle-down").toggleClass('up');
});
